export const handleDragLeavePos = (e: DragEvent, _ref, dragOverHandler?: (ev: DragEvent) => void) => {
  const el = e.currentTarget as HTMLElement;

  el.classList.remove("dragover");
  el.style.webkitBoxShadow = "";
  el.style.boxShadow = "";
  el.style.setProperty("-moz-box-shadow", "");
  el.style.removeProperty("transition");

  if (el.offsetParent instanceof HTMLElement) {
    const op = el.offsetParent;
    op.style.webkitBoxShadow = "";
    op.style.boxShadow = "";
    op.style.setProperty("-moz-box-shadow", "");
    op.style.removeProperty("transition");
  }

  const firstChild = el.firstElementChild as HTMLElement | null;
  if (
    el.getAttribute("data-component-type") === "image" &&
    firstChild?.classList.contains("builder-image--loaded")
  ) {
    firstChild.style.webkitBoxShadow = "";
    firstChild.style.boxShadow = "";
    firstChild.style.setProperty("-moz-box-shadow", "");
    firstChild.style.removeProperty("transition");
  }

  if (dragOverHandler) {
    el.removeEventListener("dragover", dragOverHandler);
  }
};
